<template>
  <!-- eslint-disable max-len -->
  <div class="route-wrapper">
    <div
      class="spotlight-card text-grey"
      style="justify-content: flex-start;"
      v-if="onSuccessfulReset"
    >
      <h2 class="text-grey">{{$t("common.thanks")}}</h2>
      {{$t("common.reset-submit")}}
    </div>
    <div class="spotlight-card" v-if="!onSuccessfulReset">
      <h2 class="text-grey">{{$t("common.reset-password")}}</h2>
      <form @submit.prevent="onSubmit">
        <div class="form-item">
          <label for="username" class="text-grey">{{$t("common.reset-mail-field")}}</label>
          <input
            id="username"
            class="text-grey"
            type="email"
            placeholder="Email"
            v-model.trim="$v.email.$model"
          />
          <p class="validation-msg" v-visible="$v.email.$error">{{$t("common.email-description")}}</p>
        </div>
        <div class="form-item">
          <button
            type="submit"
            class="text-white primary-bg-color"
            :disabled="disableButton"
            :class="{ loading: isProcessing }"
          >
            {{$t("common.request-password")}}
            <svg
              viewBox="0 0 1024 1024"
              fill="currentColor"
              width="1em"
              height="1em"
              class="spin"
            >
              <path
                d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
              />
            </svg>
          </button>
        </div>
        <div class="form-item">
          <p class="info text-grey">
            {{$t("common.remember-password")}}
            <a
              :href="'/portal/login?lang=' + getQueryParam()"
              class="primary-color"
            >{{$t("common.try-login")}}</a>
          </p>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import { getQueryParam } from "../shared/utilities";
import ConnectApi from "../api/connect.api";

export default {
  name: "resetPassword",
  components: {},
  mixins: [validationMixin],
  validations: {
    email: {
      required,
      email
    }
  },
  data() {
    return {
      onSuccessfulReset: false,
      email: "",
      disableButton: false,
      isProcessing: false,
      errors: [],
      year: new Date().getFullYear()
    };
  },
  methods: {
    getQueryParam() {
      return getQueryParam("lang");
    },
    onSubmit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.disableButton = true;
        this.isProcessing = true;
        ConnectApi.sendResetPasswordMail(this.email)
          .then(() => {
            this.isProcessing = false;
            this.disableButton = false;
            this.onSuccessfulReset = true;
          })
          .catch(err => {
            Vue.rollbar.error(
              "[portal]: Failed to send reset password mail",
              err
            );
            this.isProcessing = false;
            this.disableButton = false;
            this.onSuccessfulReset = false;
            this.$toaster.error(
              this.$i18n.messages[this.$i18n.locale].common["reset-password-error"]
            );
          });
      }
    }
  }
};
</script>


